import {isEmpty as _isEmpty, get as _get} from 'lodash';

import {renderPageTitle} from '@utils/helpers';

const resolveEntryNameForPageTitle = (formParamsId, entity) => {
    if (null === formParamsId) {
        return null;
    }

    if (entity !== undefined) {
        return entity.name;
    }

    return ' ';
};

const mapRelationIdsToDefaultValue = (formParamsId, relationItems) => {
    if (!formParamsId || _isEmpty(relationItems)) {
        return [];
    }

    return relationItems.map((item) => item.id);
};

const setTournamentFieldOptions = (form, tournaments) => {
    form.setField('tournaments', {
        options: tournaments,
        lazySearch: true,
    });
    form.setState(() => ({areTournamentsOptionsGenerated: true}));
};

const setContentCategoryFieldOptions = (form, contentCategories) => {
    form.setField('content_categories', {
        options: contentCategories,
        lazySearch: true,
    });
    form.setState(() => ({areContentCategoriesOptionsGenerated: true}));
};

const setTournamentDefaultValue = (form, selectedIds) => {
    form.setField('tournaments', {
        defaultValue: selectedIds,
    });
    form.setState(() => ({areSelectedTournamentsGenerated: true}));
};

const setContentCategoryDefaultValue = (form, selectedIds) => {
    form.setField('content_categories', {
        defaultValue: selectedIds,
    });
    form.setState(() => ({areSelectedContentCategoriesGenerated: true}));
};

const syncTournamentDefaultsFromEntity = (form, entity, tournaments, formParams) => {
    if (
        form.state.areSelectedTournamentsGenerated
        || _isEmpty(tournaments)
        || _isEmpty(entity?.tournaments)
    ) {
        return;
    }

    const selectedIds = mapRelationIdsToDefaultValue(formParams.id, entity.tournaments);
    setTournamentDefaultValue(form, selectedIds);
};

const syncContentCategoryDefaultsFromEntity = (form, entity, contentCategories, formParams) => {
    if (
        form.state.areSelectedContentCategoriesGenerated
        || _isEmpty(contentCategories)
        || _isEmpty(entity?.content_categories)
    ) {
        return;
    }

    const selectedIds = mapRelationIdsToDefaultValue(formParams.id, entity.content_categories);
    setContentCategoryDefaultValue(form, selectedIds);
};

const applyOptionsAndEntityDefaults = (form, GraphQLEntityData, entity, tournaments, contentCategories, formParams) => {
    if (GraphQLEntityData === undefined || entity === undefined) {
        return;
    }

    syncTournamentDefaultsFromEntity(form, entity, tournaments, formParams);
    syncContentCategoryDefaultsFromEntity(form, entity, contentCategories, formParams);
};

export const syncOriginEntryPointMultiselects = (form, entityKey) => {
    const {GraphQLOptionsData, GraphQLEntityData, formParams} = form.props;
    const contentCategories = GraphQLOptionsData?.contentCategories;
    const tournaments = GraphQLOptionsData?.tournaments;
    const entity = _get(GraphQLEntityData, entityKey);

    if (!form.state.areTournamentsOptionsGenerated && !_isEmpty(tournaments)) {
        setTournamentFieldOptions(form, tournaments);
    }

    if (!form.state.areContentCategoriesOptionsGenerated && !_isEmpty(contentCategories)) {
        setContentCategoryFieldOptions(form, contentCategories);
    }

    applyOptionsAndEntityDefaults(form, GraphQLEntityData, entity, tournaments, contentCategories, formParams);

    if ('function' !== typeof formParams?.setPageTitle) {
        return;
    }

    const {Model} = form.props;
    const entryName = resolveEntryNameForPageTitle(formParams.id, entity);
    const nextTitle = renderPageTitle({
        id: formParams.id,
        name: entryName,
        entity: Model.entityLabel,
    });

    if (form._lastOriginEntryPointPageTitle === nextTitle) {
        return;
    }

    form._lastOriginEntryPointPageTitle = nextTitle;
    formParams.setPageTitle(nextTitle);
};
